import { Link } from 'react-router-dom';

const footerLinks = {
  影视分类: [
    { label: '最新电影', path: '/category/movie' },
    { label: '热门电视剧', path: '/category/tv' },
    { label: '综艺节目', path: '/category/variety' },
    { label: '动漫资源', path: '/category/anime' },
  ],
  关于我们: [
    { label: '品牌介绍', path: '/about' },
    { label: '联系方式', path: '/about#contact' },
    { label: '用户协议', path: '/about' },
    { label: '隐私政策', path: '/about' },
  ],
  帮助中心: [
    { label: '常见问题', path: '/about#faq' },
    { label: '播放帮助', path: '/about' },
    { label: '投诉建议', path: '/about#contact' },
    { label: '加入我们', path: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center">
                  <i className="ri-movie-2-line text-2xl text-primary-400"></i>
                </div>
                <span className="text-xl font-heading font-bold text-background-50">
                  四虎影视
                </span>
              </div>
              <p className="text-sm leading-relaxed text-background-400">
                海量高清影视资源免费在线观看，涵盖最新电影、热门电视剧、综艺节目等内容。追剧看片首选平台。
              </p>
            </div>

            {Object.entries(footerLinks).map(([title, links]) => (
              <div key={title}>
                <h4 className="text-sm font-semibold text-background-100 mb-4">
                  {title}
                </h4>
                <ul className="space-y-2.5">
                  {links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200"
                        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; 2026 四虎影视. 本站所有资源均来自网络，仅供学习交流使用。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200">
                京ICP备XXXXXXXX号
              </a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200">
                网络视听许可证
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}